import {React} from 'common'
import {Colors, Styles} from 'appearance'
import Box from '@mui/material/Box'
import AppBar from '@mui/material/AppBar'
import LanguageMenu from './Header/LanguageMenu'
import MainMenu from './Header/MainMenu'
import MobileMenu from './Header/Mobile/MobileMenu'
import MobileSideMenu from './Header/Mobile/MobileSideMenu'
import UsePageHeader from 'logic/Page/UsePageHeader'
import HeaderToolbar from './Header/HeaderToolbar'

const PageHeader = ({toggleDrawer, open, isSearchLoading}) => {
    const {
        dances,
        isRtl,
        isFlex,
        isLoading,
        menuId,
        languageMenuId,
        mobileMenuId,
        mobileSideMenuId,
        handleMobileSideMenuOpen,
        handleMobileSearchMenuOpen,
        handleLanguageMenuOpen,
        handleProfileMenuOpen,
        handleMobileMenuOpen,
        anchorEl,
        setAnchorEl,
        languageAnchorEl,
        setLanguageAnchorEl,
        mobileMoreAnchorEl,
        setMobileMoreAnchorEl,
        mobileSideAnchorEl,
        mobileSearchAnchorEl,
        isMobileSearchMenuOpen,
        isMobileSideMenuOpen,
        handleMobileSideMenuClose,
    } = UsePageHeader()

    return (
        <Box sx={Styles.PAGE_HEADER_SX}>
            <AppBar
                position="fixed"
                open={open}
                isrtl={isRtl ? 1 : 0}
                sx={{backgroundColor: Colors.APP_GRAY_LIGHT}}>
                <HeaderToolbar
                    isFlex={isFlex}
                    dances={dances}
                    isLoading={isLoading}
                    toggleDrawer={toggleDrawer}
                    handleMobileSearchMenuOpen={handleMobileSearchMenuOpen}
                    handleMobileSideMenuOpen={handleMobileSideMenuOpen}
                    isMobileSideMenuOpen={isMobileSideMenuOpen}
                    isMobileSearchMenuOpen={isMobileSearchMenuOpen}
                    languageMenuId={languageMenuId}
                    handleLanguageMenuOpen={handleLanguageMenuOpen}
                    menuId={menuId}
                    mobileMenuId={mobileMenuId}
                    handleMobileMenuOpen={handleMobileMenuOpen}
                    handleProfileMenuOpen={handleProfileMenuOpen}
                    isSearchLoading={isSearchLoading}
                />
            </AppBar>
            <MainMenu
                menuId={menuId}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                setMobileMoreAnchorEl={setMobileMoreAnchorEl}
            />
            <MobileMenu
                mobileMenuId={mobileMenuId}
                setAnchorEl={setAnchorEl}
                mobileMoreAnchorEl={mobileMoreAnchorEl}
                mobileSearchAnchorEl={mobileSearchAnchorEl}
                setMobileMoreAnchorEl={setMobileMoreAnchorEl}
            />
            {/* <MobileSearchMenu
                dances={dances}
                isLoading={isLoading}
                mobileSearchAnchorEl={mobileSearchAnchorEl}
                isMobileSearchMenuOpen={isMobileSearchMenuOpen}
                handleMobileSearchMenuClose={handleMobileSearchMenuClose}
            /> */}
            <MobileSideMenu
                mobileSideAnchorEl={mobileSideAnchorEl}
                mobileSideMenuId={mobileSideMenuId}
                isMobileSideMenuOpen={isMobileSideMenuOpen}
                handleMobileSideMenuClose={handleMobileSideMenuClose}
            />
            <LanguageMenu
                languageAnchorEl={languageAnchorEl}
                setLanguageAnchorEl={setLanguageAnchorEl}
            />
        </Box>
    )
}

export default PageHeader
